import { render, staticRenderFns } from "./SurveyMeasures.vue?vue&type=template&id=39d16e79&scoped=true&"
import script from "./SurveyMeasures.vue?vue&type=script&lang=js&"
export * from "./SurveyMeasures.vue?vue&type=script&lang=js&"
import style0 from "./SurveyMeasures.vue?vue&type=style&index=0&id=39d16e79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d16e79",
  null
  
)

export default component.exports